export default __webpack_public_path__ + "static/JSUL_22_TEXT-d207a6824ab994881cce08e8f1910408.mp4";